import { CountryDropdown } from './CrountryDropdown';
import { filterVisiblePages, getPageCollection } from 'utils';
import Label from '@pixum/label';
import { type I18nConstants } from '../../../../types';
import './styles.css';
import { TEXT_VARIANT } from '@pixum/text';

type CountryListProps = {
  constants: I18nConstants;
};

export function CountryList(props: CountryListProps) {
  const { constants } = props;
  const pages = filterVisiblePages(getPageCollection());

  return (
    <section className="footer__country-section" id="country-list">
      <CountryDropdown pages={pages} constants={constants} />
      <ul className="footer__country-list">
        {pages.map(({ name, homepage }) => (
          <li className="footer__country-list-item" key={`country-${name}`}>
            <Label href={homepage} text={name} title={name} variant={TEXT_VARIANT.CAPTION} />
          </li>
        ))}
      </ul>
    </section>
  );
}
